/*
 * @Descripttion: 
 * @version: 
 * @Author: renqiang_hu
 * @Date: 2020-12-21 09:49:53
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2022-06-06 10:14:51
 * @FilePath: \heshan_web\src\util\socket.js
 */
import Vue from 'vue';
var websock = [];
var global_callback = null;
	//webSocket连接端口

Vue.prototype.websock = []

// ws://litai.thingcom.com/ws?type=2&gatewayId=${tenantId}&streamId=${item}&tenantId=987563
export function initWebSocket(url,index){ //初始化weosocket
    //ws地址
    var wsuri = url;
    if(wsuri){
        let res = websock.filter(v=>v.readyState===1&&v.url===url) // 连接未关闭不在创建
       
        if(res.length<1){
            websock[index] = new WebSocket(wsuri);
            Vue.prototype.websock[index] =  websock[index]
        }
        
        websock[index].onmessage = function(e){
            websocketonmessage(e);
        } 
        // websock[index].onclose = function(e){
        //     websocketclose(e);
        // }
        websock[index].onopen = function () {
            websocketOpen();
        }
        
        //连接发生错误的回调方法
        websock[index].onerror = function () {
            console.log("WebSocket连接发生错误");
        }
    }
    
}

// 实际调用的方法
export function sendSock(agentData,index,callback){  
    global_callback = callback;
    if (websock[index].readyState === websock[index].OPEN) {
    	//若是ws开启状态
        // websocketsend(agentData,index)
    }else if (websock[index].readyState === websock[index].CONNECTING) {
    	// 若是 正在开启状态，则等待1s后重新调用
        setTimeout(function () {
        	sendSock(agentData,index,callback);
        }, 1000);
    }else {
    	// 若未开启 ，则等待1s后重新调用
        setTimeout(function () {
            sendSock(agentData,index,callback);
        }, 1000);
    }
}

//数据接收
function websocketonmessage(e){ 
    
    if(e){
        global_callback(e);
    }
    
}

//数据发送
function websocketsend(agentData,index){
    websock[index].send(JSON.stringify(agentData));
}

//关闭
export function websocketclose(index){ 

    console.log("连接关闭");
        if(websock[index]){
            websock[index].close()
        }
           
}

function websocketOpen(e){
	console.log("连接成功");
}


